// import React, { useState, useContext, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import {
//     Layout,
//     Button,
//     Row,
//     Col,
//     Typography,
//     Form,
//     Input,
//     Switch,
//     Modal,
//     Select,
//     Checkbox,
//     Card,
//     Tag,
// } from "antd";
// import ActiveIcon from "../../assets/images/devies-icon.svg";
// import TotalDiviceIcon from "../../assets/images/active-devies.svg";
// import InActiveIcon from "../../assets/images/inactive-icon.svg";
// import { DashOutlined, DotChartOutlined, PlusOutlined } from "@ant-design/icons";
// import useRequest from "../../hooks/useRequest";
// import apiPath from "../../constants/apiPath";



// const DashboardWhatsappIndex = () => {

//     const navigate = useNavigate();
//     const { request } = useRequest()
//     const [loading, setLoading] = useState(false)
//     const [dataSource, setDataSource] = useState()

//     const fetchData = () => {
//         setLoading(true);
//         request({
//             url: apiPath.getCount,
//             method: "GET",
//             onSuccess: (data) => {
//                 console.log(data.data)

//                 setDataSource(data.data);
//                 // } else {

//                 // }
//                 setLoading(false);
//             },
//             onError: (error) => {

//                 setLoading(false);
//             },
//         });
//     };

//     useEffect(() => {
//         fetchData()
//     }, [])
//     return (
//         <>
//             <Card>
//                 <div className="dashboard-card-header">
//                     <Button type="primary" className="fill-btn" ><PlusOutlined /> Create Device</Button>
//                 </div>
//                 <Row gutter={[16, 16]}>
//                     <Col span={24} md={12} lg={8}>
//                         <div className="user-cards">
//                             <div className="user-card-tital">
//                                 <h2>{dataSource?.getTotalDevice}</h2>
//                                 <p>Total Devices</p>
//                             </div>
//                             <div className="user-card-icon">
//                                 <img alt="icon" src={ActiveIcon} />
//                             </div>
//                         </div>
//                     </Col>
//                     <Col span={24} md={12} lg={8}>
//                         <div className="user-cards">
//                             <div className="user-card-tital">
//                                 <h2>{dataSource?.getActiveDevice}</h2>
//                                 <p>Active Devices</p>
//                             </div>
//                             <div className="user-card-icon">
//                                 <img alt="icon" src={TotalDiviceIcon} />
//                             </div>
//                         </div>
//                     </Col>
//                     <Col span={24} md={12} lg={8}>
//                         <div className="user-cards">
//                             <div className="user-card-tital">
//                                 <h2>{dataSource?.getInActiveDevice}</h2>
//                                 <p>InActive Device</p>
//                             </div>
//                             <div className="user-card-icon">
//                                 <img alt="icon" src={InActiveIcon} />
//                             </div>
//                         </div>
//                     </Col>
//                     <Col span={24} md={12} lg={8}>
//                         <div className="user-cards">
//                             <div className="user-devies-detail">
//                                 <h6>9855685566</h6>
//                                 <p>Phone: <Link>9855685566</Link></p>
//                                 <p>Total Message</p>
//                                 <div className="status-tag">
//                                     <h5>Status:</h5>
//                                     <Tag color="success">success</Tag>
//                                 </div>
//                             </div>
//                             <Button className="user-card-edit-icon" onClick={() => navigate("/whatsapp-configuration")}>
//                                 Scan
//                             </Button>
//                         </div>
//                     </Col>
//                     <Col span={24} md={12} lg={8}>
//                         <div className="user-cards">
//                             <div className="user-devies-detail">
//                                 <h6>9855685566</h6>
//                                 <p>Total Message</p>
//                                 <div className="status-tag">
//                                     <h5>Status:</h5>
//                                     <Tag color="warning">warning</Tag>
//                                 </div>
//                             </div>
//                             <Button className="user-card-edit-icon" onClick={() => navigate("/whatsapp-configuration")}>
//                                 Scan
//                             </Button>
//                         </div>
//                     </Col>

//                 </Row>

//             </Card>

//         </>
//     );
// };

// export default DashboardWhatsappIndex;


import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Layout,
    Button,
    Row,
    Col,
    Typography,
    Form,
    Input,
    Modal,
    Select,
    Checkbox,
    Card,
    Tag,
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import ActiveIcon from "../../assets/images/devies-icon.svg";
import TotalDiviceIcon from "../../assets/images/active-devies.svg";
import InActiveIcon from "../../assets/images/inactive-icon.svg";

const DashboardWhatsappIndex = () => {
    const navigate = useNavigate();
    const { request } = useRequest();
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState();
    const [deviceDataSingle, setDeviceDataSingle] = useState();
    const [device, setDevice] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();

    const fetchData = () => {
        setLoading(true);
        request({
            url: apiPath.getCount,
            method: "GET",
            onSuccess: (data) => {
                setDataSource(data.data);
                setLoading(false);
            },
            onError: () => {
                setLoading(false);
            },
        });
    };

    const fetchDevice = () => {
        setLoading(true);
        request({
            url: apiPath.getdevice,
            method: "GET",
            onSuccess: (data) => {
                console.log(data, "daya")
                setDevice(data.data.data);
                fetchData()
                setLoading(false);
            },
            onError: () => {
                setLoading(false);
            },
        });
    };

    useEffect(() => {
        fetchData();
        fetchDevice()
    }, []);

    const handleCreateDevice = (values) => {
        request({
            url: `${deviceDataSingle ? `${apiPath.editdevice}/${deviceDataSingle._id}` : apiPath.createdevice }`,
            method: `${deviceDataSingle ? "PUT" : "POST" }`,
            data: values,
            onSuccess: () => {
                fetchData();
                fetchDevice()
                Modal.success({ title: `${deviceDataSingle ? "Device Updated Successfully" : "Device Created Successfully" }` });
                setIsModalOpen(false);
                setDeviceDataSingle();
                form.resetFields();
            },
            onError: (err) => {
                console.log(err, "err")
                setDeviceDataSingle();
                Modal.error({ title: "Failed to create device", content: err.response.data.message });
            },
        });
    };

    const handleStatusChange = (deviceId) => {
        Modal.confirm({
            title: "Are you sure you want to change the status?",
            okText: "Yes",
            className: "tab-modal",
            cancelText: "No",
            onOk: () => {
                setLoading(true);
                request({
                    url: `${apiPath.deviceStatusChange}/${deviceId}`,
                    method: "GET",
                    onSuccess: () => {
                        Modal.success({ title: "Device status updated successfully!" });
                        fetchDevice();
                    },
                    onError: (err) => {
                        Modal.error({ title: "Failed to update status", content: err.message });
                    },
                    onFinally: () => setLoading(false),
                });
            },
        });
    };

    const handleEditDevice = (deviceData) => {
        setDeviceDataSingle(deviceData)
        form.setFieldsValue({
            businessName: deviceData.businessName,
            deviceNumber: deviceData.deviceNumber,
        });

        setIsModalOpen(true);
        // Optional: Store device ID in state to know whether it’s an edit or new
    };
    const handleDeleteDevice = (id) => {
        Modal.confirm({
            title: "Are you sure you want to delete this device?",
            okText: "Yes, Delete",
            cancelText: "Cancel",
            onOk: () => {
            request({
                url: `${apiPath.deletedevice}/${id}`,
                method: "DELETE",
                onSuccess: () => {
                Modal.success({ title: "Device deleted successfully!" });
                fetchDevice();
                },
                onError: (err) => {
                Modal.error({ title: "Failed to delete device", content: err.message });
                },
            });
            },
        });
    };

    return (
        <>
            <Card>
                <div className="dashboard-card-header">
                    <Button type="primary" className="fill-btn" onClick={() => setIsModalOpen(true)}>
                        <PlusOutlined /> Create Device
                    </Button>
                </div>
                <Row gutter={[16, 16]}>
                    <Col span={24} md={12} lg={8}>
                        <div className="user-cards">
                            <div className="user-card-tital">
                                <h2>{dataSource?.getTotalDevice}</h2>
                                <p>Total Devices</p>
                            </div>
                            <div className="user-card-icon">
                                <img alt="icon" src={ActiveIcon} />
                            </div>
                        </div>
                    </Col>
                    <Col span={24} md={12} lg={8}>
                        <div className="user-cards">
                            <div className="user-card-tital">
                                <h2>{dataSource?.getActiveDevice}</h2>
                                <p>Active Device</p>
                            </div>
                            <div className="user-card-icon user-card-icon-active">
                                <img alt="icon" src={TotalDiviceIcon} />
                            </div>
                        </div>
                    </Col>
                    <Col span={24} md={12} lg={8}>
                        <div className="user-cards">
                            <div className="user-card-tital ">
                                <h2>{dataSource?.getInActiveDevice}</h2>
                                <p>Inactive Device</p>
                            </div>
                            <div className="user-card-icon user-card-icon-inactive">
                                <img alt="icon" src={InActiveIcon} />
                            </div>
                        </div>
                    </Col>
                    {device.length > 0 && device.map((data) => (
                        <Col span={24} md={12} lg={8}>
                            <div className="user-cards">
                                <div className="user-devies-detail">
                                    {data.businessName && <h6>{data.businessName}</h6>}

                                    <p>Phone: <Link>{data.deviceNumber}</Link></p>
                                    {/* <p>Total Message</p> */}
                                    <div className="status-tag">
                                        <h5>Status:</h5>
                                        <Tag
                                            color={data.is_status ? "success" : "error"}
                                            onClick={() => handleStatusChange(data._id)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {data.is_status ? "Active" : "Inactive"}
                                        </Tag>
                                    </div>

                                  
                                </div>
                                <div className="user-gread-btn">

                                    {data.is_status ?
                                        <Button className="user-card-edit-icon" onClick={() => navigate(`/whatsapp-configuration/${data._id}`)}>
                                            Scan
                                        </Button>
                                     : ''}

                                    <div style={{ marginTop: 10, display: "flex", gap: "8px" }}>
                                        <Button
                                            className="user-button-btn"
                                            icon={<EditOutlined />}
                                            onClick={() => handleEditDevice(data)}
                                        />
                                        <Button
                                            danger
                                            className="user-button-btn"
                                            icon={<DeleteOutlined />}
                                            onClick={() => handleDeleteDevice(data._id)}
                                        />
                                    </div>

                                </div>
                                    
                            </div>
                        </Col>
                    ))}

                    {/* <Col span={24} md={12} lg={8}>
                        <div className="user-cards">
                            <div className="user-devies-detail">
                                <h6>9855685566</h6>
                                <p>Total Message</p>
                                <div className="status-tag">
                                    <h5>Status:</h5>
                                    <Tag color="warning">warning</Tag>
                                </div>
                            </div>
                            <Button className="user-card-edit-icon" onClick={() => navigate("/whatsapp-configuration")}>
                                Scan
                            </Button>
                        </div>
                    </Col> */}

                </Row>
            </Card>

            {/* Modal for Create Device */}
            <Modal
                title={`${deviceDataSingle ? "Edit" : "Create New" } Device`}
                open={isModalOpen}
                className="tab_modal"
                onCancel={() => {setIsModalOpen(false);setDeviceDataSingle() }}
                onOk={() => form.submit()}
                okText="Submit"
                confirmLoading={loading}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleCreateDevice}
                >
                    <Form.Item
                        name="businessName"
                        label="Business Name"
                        rules={[{ required: true, message: "Please enter business name" }]}
                    >
                        <Input placeholder="Enter business name" />
                    </Form.Item>
                    <Form.Item
                        name="deviceNumber"
                        label="Device Number"
                        rules={[{ required: true, message: "Please enter device number" }]}
                    >
                        <Input placeholder="Enter device number" />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default DashboardWhatsappIndex;
